import { CheckIncustomerConstant } from "./CheckInCustomerConstant";

const CheckIncustomerAction = {};


CheckIncustomerAction.getNavigationData = ({
  chargingStation,
  model,
  connector,
  manufacturer,
  startDate,
  endDate,
  search,
  page,
  limit,
  filter
}) => {
  return {
    type: CheckIncustomerConstant.CHECKIN_CUSTOMER_SAGA,
    payload: {
      chargingStation:chargingStation,
      model:model,
      connector:connector,
      manufacturer:manufacturer,
      startDate:startDate,
      endDate:endDate,
      search:search,
      page:page,
      limit:limit,
      filter:filter,
    },
  };
};
// CheckIncustomerAction.postcheckindetailsData = (payload) => {
  
//   return {
//     type: CheckIncustomerConstant.ADD_CHECKIN_CUSTOMER_DETAIL_SAGA,
//     payload,
//   };
// };

CheckIncustomerAction.getCheckinCustomerbyidData = (id) => {
  
  return {
    type: CheckIncustomerConstant.CHECKIN_CUSTOMER_DETAILS_BY_ID_SAGA,
    payload: id,
  };
};
CheckIncustomerAction.getCheckinNavigationbyidData = (id) => {
  
  return {
    type: CheckIncustomerConstant.CHECKIN_SEARCH_NAVIGATION_BY_ID_SAGA,
    payload: id,
  };
};
CheckIncustomerAction.getCheckinSearchHistorybyidData = (id) => {
  
  return {
    type: CheckIncustomerConstant.CHECKIN_SEARCH_HISTORY_BY_ID_SAGA,
    payload: id,
  };
};
CheckIncustomerAction.getCheckinVehiclesbyidData = (id) => {
  
  return {
    type: CheckIncustomerConstant.CHECKIN_VEHICLE_BY_ID_SAGA,
    payload: id,
  };
};
CheckIncustomerAction.getCheckinHistoryChargingbyidData = (id) => {
  
  return {
    type: CheckIncustomerConstant.CHECKIN_CHARGING_HISTORY_BY_ID_SAGA,
    payload: id,
  };
};

export { CheckIncustomerAction };
